/** @file A long echoed or reported string cut to its head with an ellipsis, never inside a surrogate pair. */

/** `text` when it has at most `max` UTF-16 units; else its first `max` units (one fewer when the last kept unit is a
 *  high surrogate, so no lone half of an emoji is left, M-6) and "…". */
export function clipText(text: string, max: number): string {
  if (text.length <= max) return text;
  const last = text.charCodeAt(max - 1);
  return `${text.slice(0, last >= 0xd800 && last <= 0xdbff ? max - 1 : max)}…`;
}
